import {Component, OnInit, OnChanges, ViewChild, SimpleChanges, DestroyRef, inject} from '@angular/core';
import { languageAssignmentsFilterFieldMap as fieldMap } from '@emm/shared/formly/maps/language-assignments-filter-config';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LanguageAssignmentsFormComponent } from '../language-assignments-form/language-assignments-form.component';
import {formatDate} from '@angular/common';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {LanguageAssignmentsFacadeService} from '@emm/management/services/language-assignments-facade.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UserService} from '@emm/core/services/user.service';


@Component({
  selector: 'emm-language-assignments',
  templateUrl: './language-assignments.component.html',
  styleUrls: ['./language-assignments.component.scss']
})
export class LanguageAssignmentsComponent implements OnInit, OnChanges {

    @ViewChild(LanguageAssignmentsFormComponent) languageAssignmentsForm: LanguageAssignmentsFormComponent;
    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    isReadOnly$ = this.authFacade.isReadOnly$;
    isReadOnly = this.userService.hasLoginRole();
    isSuperAdmin = this.userService.hasSuperAdminRole();
    isAdmin = this.userService.hasAdminRole();
    isAuthor = this.userService.hasAuthorRole();

  fields$ = of(null).pipe(map((_) => [fieldMap['name']()]));
  centerLoading$ = this.languageAssignmentFacade.centerLoading$;
  filteredOptions$ = this.languageAssignmentFacade.filteredOptions$;
  effectiveDate;
  storeNumber: any;
  nodes = [];
  isEnglish;
  isSpanish;
  showResult;

  constructor(
    private authFacade: AuthFacadeService,
    private languageAssignmentFacade: LanguageAssignmentsFacadeService,
    private managementApiService: ManagementApiService,
    private userService: UserService,) {}

  ngOnInit(): void {
    this.languageAssignmentFacade.init();
  }

  ngOnChanges(changes: SimpleChanges) {
      this.getLanguageAssignments();
  }

    onFilter(filtered) {
    this.languageAssignmentFacade.searchLocation(filtered);
  }

  onSelectingLocation(selected) {
    this.nodes = [];
    this.storeNumber = selected.tag;

    this.getLanguageAssignments();
  }

  getLanguageAssignments(): void {
      this.managementApiService.getLanguageAssignment(this.storeNumber)
          .pipe(
              takeUntilDestroyed(this.destroyRef)
          )
          .subscribe((result) => {
          JSON.stringify(result);
          this.effectiveDate = formatDate(result.effectiveDate, 'yyyy-MM-dd', 'en-US');
          this.isEnglish = result.english.toString().toUpperCase();
          this.isSpanish = result.spanish.toString().toUpperCase();
          this.showResult = true;
      });
  }
}
